<!-- Summary Cards -->
<div class="summary-section" *ngIf="summary">
  <div class="summary-card">
    <div class="summary-value">{{ summary.totalCalls }}</div>
    <div class="summary-label">Total Calls</div>
  </div>
  <div class="summary-card">
    <div class="summary-value">{{ summary.successCalls }}</div>
    <div class="summary-label">Successful</div>
  </div>
  <div class="summary-card highlight">
    <div class="summary-value" [class.good]="summary.avgTtfbMs < 1000" [class.bad]="summary.avgTtfbMs >= 1000">
      {{ summary.avgTtfbMs }}ms
    </div>
    <div class="summary-label">Avg TTFB</div>
  </div>
  <div class="summary-card highlight">
    <div class="summary-value" [class.good]="summary.underOneSecPercent >= 90" [class.bad]="summary.underOneSecPercent < 90">
      {{ summary.underOneSecPercent }}%
    </div>
    <div class="summary-label">Under 1s</div>
  </div>
  <div class="summary-card">
    <div class="summary-value">{{ summary.avgFirstTokenMs }}ms</div>
    <div class="summary-label">Avg First Token</div>
  </div>
  <div class="summary-card">
    <div class="summary-value">{{ summary.avgDurationMs }}ms</div>
    <div class="summary-label">Avg Total</div>
  </div>
</div>


<!-- Header + Filters (single row) -->
<div class="section-header">
  <h3>Streaming Metrics</h3>
  <div class="filter-row">
    <select [(ngModel)]="searchProvider" (change)="onSearch()">
      <option value="">All Providers</option>
      <option value="anthropic">Anthropic</option>
      <option value="openai">OpenAI</option>
      <option value="vertex-ai-claude">Vertex AI Claude</option>
    </select>
    <select [(ngModel)]="searchStatus" (change)="onSearch()">
      <option value="">All Statuses</option>
      <option value="success">Success</option>
      <option value="error">Error</option>
      <option value="aborted">Aborted</option>
    </select>
    <select [(ngModel)]="searchInterviewType" (change)="onSearch()">
      <option value="">All Types</option>
      <option value="practice">Practice</option>
      <option value="screening">Screening</option>
      <option value="firstround">First Round</option>
      <option value="finalround">Final Round</option>
    </select>
    <button class="clear-btn" (click)="clearFilters()" *ngIf="searchProvider || searchStatus || searchInterviewType">
      Clear
    </button>
  </div>
</div>

<!-- Table -->
<div class="card">
  <div class="table-wrapper">
    <table>
      <thead>
        <tr>
          <th>Logged User</th>
          <th>Prompt ID</th>
          <th>Type</th>
          <th>Provider</th>
          <th>Model</th>
          <th>Time</th>
          <th>TTFB</th>
          <th>First Token</th>
          <th>Total</th>
          <th>Status</th>
        </tr>
      </thead>
      <tbody>
        <!-- Skeleton loading -->
        <ng-container *ngIf="loading">
          <tr *ngFor="let _ of [1,2,3,4,5]" class="skeleton-row">
            <td><div class="skeleton-cell"></div></td>
            <td><div class="skeleton-cell"></div></td>
            <td><div class="skeleton-cell"></div></td>
            <td><div class="skeleton-cell"></div></td>
            <td><div class="skeleton-cell"></div></td>
            <td><div class="skeleton-cell"></div></td>
            <td><div class="skeleton-cell"></div></td>
            <td><div class="skeleton-cell"></div></td>
            <td><div class="skeleton-cell"></div></td>
            <td><div class="skeleton-cell"></div></td>
          </tr>
        </ng-container>

        <!-- Data rows -->
        <ng-container *ngIf="!loading">
          <tr *ngFor="let m of sortedMetrics">
            <td>{{ m.userName || m.userId || '-' }}</td>
            <td class="prompt-cell">{{ m.promptId || '-' }}</td>
            <td>
              <span class="type-badge" [attr.data-type]="m.interviewType">{{ m.interviewType || '-' }}</span>
            </td>
            <td>
              <span class="provider-badge" [attr.data-provider]="m.provider">{{ m.provider }}</span>
            </td>
            <td class="model-cell" [title]="m.model">{{ m.model }}</td>
            <td class="time-cell">{{ formatTimestamp(m.timestamp) }}</td>
            <td [class.ttfb-good]="isUnderOneSecond(m.ttfbMs)" [class.ttfb-bad]="m.ttfbMs >= 1000">
              <strong>{{ formatMs(m.ttfbMs) }}</strong>
            </td>
            <td>{{ formatMs(m.firstTokenMs) }}</td>
            <td>{{ formatMs(m.totalDurationMs) }}</td>
            <td>
              <span class="status-badge" [attr.data-status]="m.status">{{ m.status }}</span>
            </td>
          </tr>
        </ng-container>

        <!-- Empty state -->
        <tr *ngIf="!loading && metrics.length === 0">
          <td colspan="10" class="empty-state">No streaming metrics recorded yet</td>
        </tr>
      </tbody>
    </table>
  </div>

  <!-- Pagination -->
  <div class="pagination-bar" *ngIf="metrics.length > 0">
    <div class="pagination-info">
      Showing {{ page * size + 1 }}-{{ Math.min((page + 1) * size, totalElements) }} of {{ totalElements }}
    </div>
    <div class="pagination-pages">
      <span class="page-btn" [class.disabled]="page === 0" (click)="goToPage(page - 1)">Prev</span>
      <span *ngFor="let p of paginationPages"
            class="page-btn"
            [class.active]="p === page"
            [class.ellipsis]="p === -1"
            (click)="goToPage(p)">
        {{ displayPage(p) }}
      </span>
      <span class="page-btn" [class.disabled]="page >= totalPages - 1" (click)="goToPage(page + 1)">Next</span>
    </div>
    <div class="page-size-select">
      <select [(ngModel)]="size" (change)="onPageSizeChange()">
        <option [value]="10">10</option>
        <option [value]="20">20</option>
        <option [value]="50">50</option>
      </select>
      <span>per page</span>
    </div>
  </div>
</div>
